import { Component, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { PagesServices } from '../../pages.services';

@Component({
  selector: 'ngx-dialog-assign-folder',
  templateUrl: './dialog-assign-folder.component.html',
  styleUrls: ['./dialog-assign-folder.component.scss']
})
export class DialogAssignFolderComponent implements OnInit {

  dataList: string[] = [];
  selectedCase: string = "";

  settings = {
    mode: "external",
    add: null,
    edit: null,
    delete: null,
    actions: null,
    selectedRowIndex: -1,
    pager: {
        perPage: 5,
    },
    columns: {
        name: {
            title: 'Search..',
        }
    }
  };

  constructor(
    protected ref: NbDialogRef<DialogAssignFolderComponent>,
    private _pagesServices: PagesServices,
    ) { }

    ngOnInit(): void {
      this._pagesServices.ListMyFolders().subscribe(response => {
        if(response.data) {
          this.dataList = response.data;
        }
      });
    }

    userRowSelect(event) {
      if(event !== null){
        if(event.isSelected) {
          this.selectedCase = event.data.id;
        } else {
          this.selectedCase = "";
        }
      }
    }
  
    AddToFolder() {
      this.ref.close({status:true, folderId: this.selectedCase});
    }
  
    cancel() {
      this.ref.close({action:false});
    }

}
